import { render } from "./save-report-button.vue?vue&type=template&id=fbb8764c&ts=true"
import script from "./save-report-button.vue?vue&type=script&lang=ts"
export * from "./save-report-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__